import { defineMessages } from 'react-intl-next';

export default defineMessages({
    loadErrorTitle: {
        defaultMessage: 'Error submitting form',
        description: 'Error title shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.title',
    },
    loadErrorDesc: {
        defaultMessage:
            'We were unable verify that you are not a bot. Reload your form and give it another try. If the problem persists please contact your Administrator.',
        description: 'Error description shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.desc',
    },
});
